import React, { useEffect, useState } from 'react';

import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import SelectedContainer from '../Modals/common/SelectedContainer.js';
import ResizableIconButton from '../../common/CustomMaterial/ResizableIconButton';

const useStyles = makeStyles({
    myComponent: {
        '& .MuiIconButton-root': {
            padding: 0,
            boxShadow: '0 0 4px 4px rgb(0 0 0 / 13%)'
        }
    }
});

const TextsFilter = ({ value, onChange, maxTags = 20, maxTagChars = 15 }) => {
    const classes = useStyles();
    const [newText, setNewText] = useState('');
    const [texts, setTexts] = useState(value ? value : []);
    const [isAddDisabled, setIsAddDisabled] = useState(false);

    useEffect(() => {
        setIsAddDisabled((maxTags && texts.length >= maxTags) || texts.includes(newText) || !newText);
    }, [maxTags, texts, newText, setIsAddDisabled]);

    const onAddText = () => {
        const newTexts = [...texts, newText];
        onChange(newTexts);
        setTexts(newTexts);
        setNewText('');
    };

    const onRemoveText = (key) => {
        const newTexts = texts.filter((text) => text !== key);
        onChange(newTexts);
        setTexts(newTexts);
    };

    const onKeyPressHandler = (event) => {
        if (event.key === 'Enter' && !isAddDisabled) {
            onAddText();
        }
    };

    return (
        <div className="items-center content-center">
            <div
                className={`p-1.5 border-solid border-b border-stone-200 ${classes.myComponent}`}
                onKeyPress={onKeyPressHandler}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <input
                            className="block outline-none border-none w-[260px]"
                            maxLength={100}
                            autoFocus
                            onChange={(event) => setNewText(event.target.value)}
                            value={newText}
                            placeholder="Search..."
                        />
                    </Grid>
                    <Grid item>
                        <ResizableIconButton
                            onClick={onAddText}
                            disabled={isAddDisabled}
                            color="primary"
                            size="medium"
                            aria-label="add">
                            <AddIcon />
                        </ResizableIconButton>
                    </Grid>
                </Grid>
            </div>
            <div className="p-1.5">
                <SelectedContainer items={texts} onRemove={onRemoveText} maxChars={maxTagChars} />
            </div>
        </div>
    );
};

export default TextsFilter;
